module.exports = __webpack_public_path__ + "static/media/no-movie-img.668c43fc.jpg";